<template>
  <draggable
    tag="div"
    :list="list"
    :group="{ name: `depth_${depth}`, put: false }"
    handle=".btnHandle"
    animation="300"
    class="categoryTree">
    <transition-group type="transition"
      tag="div">
      <div
        v-for="item in list"
        :key="item.categoryId"
        class="item">
        <div class="itemWrap">
          <div class="itemInfo">
            <button
              v-if="item.subCategory && item.subCategory.length"
              type="button"
              class="btnFold"
              @click="foldItem(item.categoryId)"></button>
            <SetLanguageValue class="categoryName"
              :locale="locale"
              :langValue="item.categoryLabel" />
            <button
              v-if="depth < 2"
              type="button"
              class="btnAdd"
              @click="addChildren(item)"></button>
            <button
              type="button"
              class="btnDel"
              @click="removeItem(item.categoryId)"></button>
          </div>
          <button
            type="button"
            class="btnHandle"></button>
        </div>
        <MyCollectionCategory
          v-if="item.subCategory && item.subCategory.length && !foldItems.includes(item.categoryId)"
          :locale="locale"
          :list="item.subCategory"
          :defaultLang="defaultLang"
          :depth="depth + 1"
          :class="{childrenGroup: depth > 1}"
          @addChildren="addChildren"
          @removeItem="removeItem"
          @setLanguage="setLanguage"/>
      </div>
    </transition-group>
  </draggable>
</template>

<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import LANG from '@/common/lang'
import regExp from '@/common/regExp'
import UNIQUE from '@/common/unique'
import SetLanguageValue from '@/components/Util/SetLanguageValue'

export default {
  name: 'MyCollectionCategory',
  props: {
    locale: Object,
    list: Array,
    defaultLang: String,
    depth: {
      type: Number,
      default: 1,
    }
  },
  components: {
    draggable,
    SetLanguageValue
  },
  computed: {
  },
  data () {
    return {
      foldItems: []
    }
  },
  methods: {
    setLanguage (categoryId, categoryLabel) {
      this.$emit('setLanguage', categoryId, categoryLabel)
    },
    itemClass (item) {
      return this.list.includes(item) ? 'item' : 'childrenItem'
    },
    addChildren (item) {
      if (!item.subCategory) {
        this.$set(item, 'subCategory', [])
      }
      item.subCategory.push({
        categoryId: UNIQUE.uniqueId8(),
        categoryLabel: LANG.valueObj('')
      })
    },
    removeItem (categoryId) {
      this.$emit('removeItem', categoryId)
    },
    foldItem (categoryId) {
      function toggleItem(arr, item) {
        const index = arr.indexOf(item)
        if (index !== -1) {
          arr.splice(index, 1)
        } else {
          arr.push(item)
        }
        return arr
      }
      this.foldItems = toggleItem(this.foldItems, categoryId)
    }
  }
}
</script>

<style lang="scss" scoped>
.categoryTree {
  .item {
    margin-bottom: 8px;
    .categoryTree {
      margin-left: 24px;
      .item {
        margin-top: 2px;
        margin-bottom: 0;
      }
    }
  }
  .itemWrap {
    display: flex;
  }
  .btnHandle {
    position: relative;
    width: 36px;
    border: 1px solid $color-lgrey2;
    border-left: none;
    border-radius: 0 4px 4px 0;
    background: $bg-default;
    cursor: move;
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url('~@/assets/img/move.png') 50% 50% / 16px no-repeat;
      opacity: 0.2;
    }
  }
  .itemInfo {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 0 0 0 12px;
    border: 1px solid $color-lgrey2;
    border-radius: 4px;
    background-color: $color-white;
    button {
      width: 36px;
      height: 36px;
      font-size: 0;
      &:before {
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        background: url('~@/assets/img/ico_arrow.svg') 50% 50% / 16px no-repeat;
        opacity: 0.4;
      }
    }
    .checkbox {
      margin-right: 8px;
      [disabled] + label {
        opacity: 0.6;
      }
    }
    .name {
      flex: 1;
    }
    .btnFold {
      &:before {
        background-image: url('~@/assets/img/ico_arrow.svg');
      }
    }
    .btnAdd {
      height: 40px;
      border: 1px dashed $color-lgrey2;
      border-radius: 4px;
      background-color: $bg-default;
      &:before {
        background-image: url('~@/assets/img/ico_plus.svg');
        opacity: 0.2;
      }
    }
    .btnDel {
      height: 100%;
      &:before {
        background: url('~@/assets/img/ico_close_black.svg') calc(100% - 8px) 8px / 16px no-repeat;
        opacity: 0.2;
      }
    }
    .categoryName {
      flex: 1;
      margin: 4px;
    }
  }
}
</style>
